/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineRegionDto } from './traveline-region-dto';
import {
    TravelineRegionDtoFromJSON,
    TravelineRegionDtoFromJSONTyped,
    TravelineRegionDtoToJSON,
    TravelineRegionDtoToJSONTyped,
} from './traveline-region-dto';

/**
 * Список регионов
 * @export
 * @interface TravelineRegionsResponseDto
 */
export interface TravelineRegionsResponseDto {
    /**
     * Список регионов
     * @type {Array<TravelineRegionDto>}
     * @memberof TravelineRegionsResponseDto
     */
    regions: Array<TravelineRegionDto>;
}

/**
 * Check if a given object implements the TravelineRegionsResponseDto interface.
 */
export function instanceOfTravelineRegionsResponseDto(value: object): value is TravelineRegionsResponseDto {
    if (!('regions' in value) || value['regions'] === undefined) return false;
    return true;
}

export function TravelineRegionsResponseDtoFromJSON(json: any): TravelineRegionsResponseDto {
    return TravelineRegionsResponseDtoFromJSONTyped(json, false);
}

export function TravelineRegionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineRegionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'regions': ((json['regions'] as Array<any>).map(TravelineRegionDtoFromJSON)),
    };
}

  export function TravelineRegionsResponseDtoToJSON(json: any): TravelineRegionsResponseDto {
      return TravelineRegionsResponseDtoToJSONTyped(json, false);
  }

  export function TravelineRegionsResponseDtoToJSONTyped(value?: TravelineRegionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'regions': ((value['regions'] as Array<any>).map(TravelineRegionDtoToJSON)),
    };
}

